module.exports = __webpack_public_path__ + "img/piece-locked-7.1cb33427.svg";